module.exports = __webpack_public_path__ + "static/media/gamesWon_250_500.a0201285.png";